<template>
  <RsButton
    v-rs-tooltip.hover
    class="rs-userpilot-help"
    icon="lightbulb"
    weight="fas"
    variant="secondary"
    rounded
    icon-only
    :title="tooltip"
    @click="handleClick"
  />
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'RsUserpilotHelp',

  props: {
    /**
     * Callback to fire a Userpilot action (e.g. trigger a flow or resource centre item).
     * When provided it will be called on click; otherwise a console warning appears.
     */
    action: {
      type: Function as PropType<() => void>,
      default: null,
    },

    /** Optional tooltip text shown on hover. */
    tooltip: {
      type: String,
      default: '',
    },
  },

  methods: {
    handleClick() {
      if (this.action) {
        this.action();
      } else {
        console.warn('[RsUserpilotHelp] No action provided. Pass an :action prop to trigger a Userpilot flow.');
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.rs-userpilot-help {
  width: 22px !important;
  height: 22px !important;
  font-size: 0.7rem;
}
</style>
